import { useSelector } from 'react-redux';

import { exceptFieldQuery } from '../SearchPage.duck';

/**
 * The ACTIVE-field exception (faceted-search standard): for a field the
 * shopper has already filtered, its own option list must be computed against
 * all OTHER filters — otherwise one pick either collapses the list to itself
 * (plain narrowing) or balloons it to every option ever (the v1 fallback).
 *
 * The search page loads it with each search (SearchPage.duck loadData). Returns
 * the field's values present while `enabled` (its UI is open and it has a
 * selection), or null while unknown — callers then show the usual list.
 */
const useExceptFieldPresence = (urlQueryParams, filterConfig, enabled) => {
  const key = filterConfig ? exceptFieldQuery(urlQueryParams, filterConfig).key : null;
  const values = useSelector(state => (key ? state.SearchPage.exceptFieldPresence[key] : null));
  return enabled && values ? values : null;
};

export default useExceptFieldPresence;
